export default "__VITE_ASSET__3d7eae96__"